import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import type { EntityVault } from '@/types/vault';
import getRelevantDis from './utils/get-relevant-dis';
type UseDecryptOnboardingProps = {
  entity: Entity;
  onboarding: EntityOnboarding;
  onDecryptSuccess: (vault: VaultType) => void;
  vaultData: VaultType | undefined;
};

/** "Decrypt all" for the vault as of an onboarding. */
const useDecryptOnboarding = t0 => {
  const $ = _c(17);
  const {
    entity,
    onboarding,
    onDecryptSuccess,
    vaultData
  } = t0;
  const decryptControls = useDecryptControls();
  let fields;
  let t1;
  if ($[0] !== decryptControls || $[1] !== onboarding.seqno || $[2] !== vaultData?.vault) {
    let t2;
    if ($[5] !== vaultData?.vault) {
      t2 = vaultData?.vault || {};
      $[5] = vaultData?.vault;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    fields = getRelevantDis(Object.keys(t2) as DataIdentifier[], onboarding.seqno?.toString());
    t1 = decryptControls.isDecrypting(fields);
    $[0] = decryptControls;
    $[1] = onboarding.seqno;
    $[2] = vaultData?.vault;
    $[3] = fields;
    $[4] = t1;
  } else {
    fields = $[3];
    t1 = $[4];
  }
  const isDecrypting = t1;
  let t2;
  if ($[7] !== decryptControls || $[8] !== entity || $[9] !== fields || $[10] !== onDecryptSuccess || $[11] !== onboarding.id || $[12] !== onboarding.seqno) {
    t2 = async () => {
      const response = await decryptControls.decrypt({
        entity,
        fields,
        reason: `Examining onboarding ${onboarding.id}`
      });
      const vault = Object.entries(response ?? {}).reduce((acc, t3) => {
        const [key, value] = t3;
        const di = onboarding.seqno ? key.split(":")[0] : key;
        acc[di] = value;
        return acc;
      }, {} as EntityVault);
      onDecryptSuccess({
        vault,
        transforms: {}
      });
    };
    $[7] = decryptControls;
    $[8] = entity;
    $[9] = fields;
    $[10] = onDecryptSuccess;
    $[11] = onboarding.id;
    $[12] = onboarding.seqno;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const decrypt = t2;
  let t3;
  if ($[14] !== decrypt || $[15] !== isDecrypting) {
    t3 = {
      decrypt,
      isDecrypting
    };
    $[14] = decrypt;
    $[15] = isDecrypting;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};
export default useDecryptOnboarding;